import { render, staticRenderFns } from "./GlobalConfigCardBulkyGoodsSurcharge.vue?vue&type=template&id=d19ac90c&scoped=true"
import script from "./GlobalConfigCardBulkyGoodsSurcharge.vue?vue&type=script&lang=ts"
export * from "./GlobalConfigCardBulkyGoodsSurcharge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19ac90c",
  null
  
)

export default component.exports